import React, { Component } from 'react'
import $ from 'jquery'
import moment from "moment";
import Table from "react-bootstrap/Table";
import IconComponent from "./IconComponent";
import { Button, Image, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Loader from 'react-loader-spinner';
import { MediaBaseUrl, SW_LOGO_ICON } from '../../../../../actions/api';
import { FontAwesomeIcon } from '../../../../CommonComponents/AssetsHelper';
import { windowOpen } from '../../../../../utils';


const hideDropDownArrow = (lists) => {
    if (lists && lists.invoices && Object.keys(lists.invoices).length > 0) {
        return false;
    }
    return true;
}
class AllSubscriptions extends Component {

    componentDidMount() {
        $(document).ready(function ($) {
            $('#accordionExample').find('.accordion-link').click(function () {
                var isActive = $(this).hasClass("active");
                $('.accordion-link').removeClass('active');
                if (!isActive) {
                    $(this).toggleClass('active');
                }

            });
            $('#addonSubscriptionAccordion').find('.accordion-link').click(function () {
                var isActive = $(this).hasClass("active");
                $('.accordion-link').removeClass('active');
                if (!isActive) {
                    $(this).toggleClass('active');
                }

            });
            $('#ugcSubscriptionAccordion').find('.accordion-link').click(function () {
                var isActive = $(this).hasClass("active");
                $('.accordion-link').removeClass('active');
                if (!isActive) {
                    $(this).toggleClass('active');
                }

            });

            $("#addCard").click(function () {
                $(this).toggleClass('active');
                $(".card-field").toggle();
            });
        });
    }

    openCancellation = (item) => {
        const { productCancellation, handleParentStatus } = this.props;
        handleParentStatus(true);
        productCancellation(item.userProduct);
    }



    render() {
        const { changePlan, productDetails, previewInvoice, invoiceId, downloadLoading, cardData } = this.props
        return <>
            <div className="subscription-plan-table table-responsive bg-white rounded accordion mb-8" id="accordionExample">
                <Table className="table plan_sub_table mb-0">
                    <thead>
                        <tr>
                            <th>Product Plan</th>
                            <th>Pricing</th>
                            <th>Expiry at</th>
                            <th>Status</th>
                            <th>Card & Billing Info</th>
                            <th align={"right"} style={{ textAlign: "right" }}>Plan Action</th>
                        </tr>
                    </thead>
                </Table>


                {productDetails &&
                    productDetails.map((item) => {
                        const productId = (item.Product.id == 1) ? 6 : item.Product.id;
                        return <>
                            <div className="accordion-item border-0" key={item.Product.id}>
                                <table className="table plan_sub_table m-0">
                                    <tbody>
                                        <tr>
                                            <td>
                                                <div className="d-flex align-items-center flex-nowrap">
                                                    {!hideDropDownArrow(item) ? <div className="flex-shrink-0 me-4" id="headingOne">
                                                        {item.invoices && item.invoices.length > 0 ? (
                                                            <Button variant=''
                                                                className="accordion-link me-4 p-0 bg-transparent shadow-none accoudion-arrow border-0 collapsed"
                                                                data-bs-toggle="collapse"
                                                                data-bs-target={`#allInvoice_of_${item.Product.id}`}
                                                                aria-expanded="false"
                                                                aria-controls="accordion"
                                                            >
                                                                {/* <span className="svg-icon svg-icon-md"> */}
                                                                <IconComponent class_name={"icon"}>
                                                                    <FontAwesomeIcon type={'solid'} icon={'chevron-left'} iconClass={'text-secondary'} />
                                                                </IconComponent>
                                                                {/* </span> */}
                                                            </Button>
                                                        ) : (
                                                            ""
                                                        )}
                                                    </div> : null}
                                                    <div className="flex-shrink-0 me-4">
                                                        <div className="symbol symbol-35">
                                                            <Image className="img-fluid" src={SW_LOGO_ICON} height={35} width={35} alt="" />
                                                        </div>
                                                    </div>
                                                    <div className="d-flex align-items-center justify-content-between flex-wrap mt-2">
                                                        <div className="me-3">
                                                            <h6 className="d-flex align-items-center font-weight-bolder mb-1"> Social Walls </h6>
                                                            <span className="font-weight-normal"> {item.userProduct.name} </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <p className="text-dark-75 m-0">
                                                    
                                                   {
    !item.userProduct.price || item.userProduct.price === "--"
        ? "--"
        : `$${item.userProduct.price}`
}
                                                    {/* $1220 */}
                                                </p>
                                            </td>
                                            <td>
                                                <div className="d-flex flex-column text-left">
                                                    <p className="mb-0">
                                                        {item.userProduct.endDate && item.userProduct.endDate != '' ? item.userProduct.endDate : item.userProduct.expiresAt > 0
                                                            ? moment
                                                                .unix(item.userProduct.expiresAt)
                                                                .format("Do MMM YYYY")
                                                            : `--`}
                                                        {/* 10th March 2022 */}
                                                    </p>
                                                </div>
                                            </td>
                                            <td>
                                                {item.userProduct.expiresAt > 0 ? (
                                                    moment(new Date(), "YYYY.MM.DD").unix() <
                                                        moment.unix(item.userProduct.expiresAt).add(1, 'M').unix()
                                                        ? (
                                                            <span className="label font-weight-bold label-xl label-inline label-light-success plan_status">
                                                                Active
                                                            </span>
                                                        ) : (
                                                            <span className="label font-weight-bold label-xl label-inline label-light-warning plan_status">
                                                                Expired
                                                            </span>
                                                        )
                                                ) : (
                                                    <span className="label font-weight-bold label-xl label-inline label-light-success plan_status">
                                                        Active
                                                    </span>
                                                )}
                                            </td>
                                            {/* {* CArd Data *} */}
                                            <td>
                                                {((item.userProduct.cancelSubscription == 0) && (cardData || item.userProduct.updateSubscriptionLink)) ?
                                                    <div className="card-info d-flex align-items-start">
                                                        {
                                                            cardData ? <>
                                                                <div className="card-info-left me-2">
                                                                    <Image src={`${MediaBaseUrl}payment/${cardData?.brand}.png`} alt={cardData?.brand} width={32} className="img-fluid" />
                                                                </div>
                                                                <div className="card-info-mid">
                                                                    <p className="m-0">Ending with<span>{cardData?.last4}</span></p>
                                                                    <p className="m-0">Exp.<span>{String(cardData?.exp_month).padStart(2, "0")}/{cardData?.exp_year}</span></p>
                                                                </div> </> : null
                                                        }
                                                        <div className="card-info-right ms-2">
                                                            {item.userProduct.updateSubscriptionLink ?

                                                                <OverlayTrigger placement="top" delay={{ hide: 450, show: 300 }}
                                                                    overlay={(props) => (
                                                                        <Tooltip {...props}>
                                                                            Update Card info
                                                                        </Tooltip>
                                                                    )} >
                                                                    <Button variant='link' id="tooltip-btn" data-bs-toggle="modal" data-bs-target="#feedbackModal" onClick={() => windowOpen(item.userProduct.updateSubscriptionLink, "_blank")}>
                                                                        <FontAwesomeIcon type={'solid'} icon={'edit'} />
                                                                    </Button>
                                                                </OverlayTrigger>
                                                                : null}
                                                        </div>
                                                    </div>
                                                    : <p style={{ paddingLeft: "45px" }}>--</p>}
                                            </td>

                                            <td align={"right"}>
                                                <div className="upgrade-cancel-link">
                                                    {/* <Button variant='primary' size='sm' data-product-id={item.Product.id} onClick={() => changePlan(item.Product.id)}>
                                                        <span className="navi-text upgPlan" id="upgPlan">
                                                            Change Plan 
                                                        </span>
                                                    </Button> */}
                                                    {item.userProduct.product_id != 1 && item.userProduct.cancelSubscription == 0 ? <OverlayTrigger placement="top" delay={{ hide: 450, show: 300 }}
                                                        overlay={(props) => (
                                                            <Tooltip {...props}>
                                                                Cancel Subscription
                                                            </Tooltip>
                                                        )} >
                                                        <Button variant='link' id="tooltip-btn" className="cancelSubsNew ms-3 p-2" data-bs-toggle="modal" data-bs-target="#feedbackModal" data-planid={item.userProduct.planId} data-productid={productId} data-expireat={
                                                            item.userProduct.expiresAt > 0
                                                                ? moment
                                                                    .unix(item.userProduct.expiresAt)
                                                                    .format("Do MMM YYYY")
                                                                : ``
                                                        } onClick={() => this.openCancellation(item)} >
                                                            <FontAwesomeIcon type={'solid'} icon={'xmark'} />
                                                        </Button>
                                                    </OverlayTrigger> : null}
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>{" "}
                            <div className="accordion-body p-0">
                                <div
                                    id={`${item.invoices && item.invoices.length > 0
                                        ? `allInvoice_of_${item.Product.id}`
                                        : ""
                                        }`}
                                    className="accordion-collapse invoice-data collapse"
                                >


                                    <table className="table m-0">
                                        <thead>
                                            <tr>
                                                <th>Date</th>
                                                <th>Invoice Id</th>
                                                <th>Plan</th>
                                                <th>Amount</th>
                                                <th>Status</th>
                                                <th align={"right"} style={{ textAlign: "right" }}>
                                                    Action
                                                </th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {item.invoices
                                                ? item.invoices.map((invoiceItem, index) => (
                                                    <tr key={invoiceItem.invoiceId}>
                                                        <td>{moment(invoiceItem.invoiceDate).format(
                                                            "DD MMM YYYY"
                                                        )}</td>
                                                        <td>{invoiceItem.invoiceView.invoiceId}</td>
                                                        <td>{invoiceItem?.invoiceView?.item}</td>
                                                        <td>{invoiceItem.invoiceView.currencyValue}
                                                            {invoiceItem.amount}</td>
                                                        <td>{invoiceItem.status ? (
                                                            <span className="label font-weight-bold label-xl label-inline label-light-success plan_status">
                                                                Paid
                                                            </span>
                                                        ) : (
                                                            ""
                                                        )}
                                                        </td>
                                                        <td align={"right"}>
                                                            <Button variant='link' size='sm' className='p-2' onClick={() => previewInvoice(invoiceItem, "preview")}>
                                                                <FontAwesomeIcon type={'regular'} icon={'eye'} iconClass={'text-secondary'} />
                                                            </Button>
                                                            {downloadLoading && invoiceId && invoiceId.length > 0 && invoiceId.includes(invoiceItem.invoiceId) ?
                                                                <Button variant='' className='ms-2 loader-button'>
                                                                    <Loader type="ThreeDots" color="#333333" height={18} width={18} />
                                                                </Button> :
                                                                <Button variant='link' size='sm' className="ms-1 p-2" onClick={() => previewInvoice(invoiceItem, "download")}>
                                                                    <FontAwesomeIcon type={'solid'} icon={'download'} iconClass={'text-secondary'} />
                                                                </Button>}
                                                        </td>
                                                    </tr>
                                                ))
                                                : ""}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </>
                    })}
            </div>
        </>
    }
}



export default AllSubscriptions;